import { authenticatedApiClient } from '@guiker/image-recognition-shared'
import { useAuthenticatedApiClient } from '@guiker/react-framework'

export const useImageRecognitionAuthenticatedApiClient = useAuthenticatedApiClient(authenticatedApiClient)
